import { useEffect } from 'react';
import {
  NEWRELIC_BROWSER_AGENT_IDENTIFIER as NR_AGENT_ID,
  NEWRELIC_AGENT_CONFIG,
} from '../constants/newRelic';
import {
  isAgentInWindow,
  removeAgentFromWindow,
} from '@vp/om-newrelic-tracker';
import { initializeMicroAgent } from '@vp/om-newrelic-tracker/agent';

export const InitializeNewRelic = () => {
  useEffect(() => {
    function SetupNewRelic() {
      // don't initialize if the agent is already in the window
      if (!isAgentInWindow(NR_AGENT_ID)) {
        initializeMicroAgent({
          agentId: NR_AGENT_ID,
          config: NEWRELIC_AGENT_CONFIG,
        });
      }
    }

    if (typeof window !== 'undefined') {
      SetupNewRelic();
    }

    // clean up and remove the agent from the window
    return () => {
      if (isAgentInWindow(NR_AGENT_ID)) {
        removeAgentFromWindow(NR_AGENT_ID);
      }
    };
  }, []);

  return null;
};
